import React, { Component } from "react";
import moment from "moment";
import _ from "i18n";
import {
  SVG_CHECK_APPROVER_ICON,
  SVG_CLOCK_ICON,
  SVG_REJECT_ICON,
} from "../../../services/svgIcones";
import { connect } from "react-redux";
import { getUserNameForAvatar } from "utils";
import "./TTPCard.scss";

class TTPCard extends Component {
  state = {
    showFullText: false,
  };

  toggleShowFullText = () => {
    this.setState((prevState) => ({
      showFullText: !prevState.showFullText,
    }));
  };

  render() {
    const { member, sentAt, handleSingleApprovalClick, hideSendButton } = this.props;
    const { showFullText } = this.state;
    let approvalIcon, statusStyle, approvalStatusStyle;

    if (member.decision === "ACCEPT") {
      approvalIcon = SVG_CHECK_APPROVER_ICON;
      statusStyle = "acceptStatus";
      approvalStatusStyle = "acceptApproval";
    } else if (member.decision === "DENY") {
      approvalIcon = SVG_REJECT_ICON;
      statusStyle = "rejectStatus";
      approvalStatusStyle = "rejectApproval";
    } else {
      approvalIcon = SVG_CLOCK_ICON;
      statusStyle = "pendingStatus";
      approvalStatusStyle = "pendingApproval";
    }
    let formattedDate, decisionText;
    if (member.decision === "ACCEPT") {
      formattedDate = moment(member.decideAt).fromNow();
      decisionText = _("approved");
    } else if (member.decision === "DENY") {
      formattedDate = moment.utc(member.decideAt).fromNow();
      decisionText = _("rejected");
    } else {
       formattedDate = sentAt?.date
        ? moment.utc(sentAt.date).fromNow()
        : "Date not available";
      decisionText = _("sent");
    }

    return (
      <div className={"cardCollab"}>
        <div className={"frameGlobal"}>
          <div className={"collabFrame"}>
            <div className={"imageFrame"}>
              {member.avatar !== undefined ? (
                <img
                  src={`${member.avatar}`}
                  className={"approverImage"}
                />
              ) : (
                <div className={"approverImage"}>
                  {getUserNameForAvatar(member.approverName)}
                </div>
              )}
            </div>
            <div className={"group"}>
              <div className={"approverName"}>{member.approverName}</div>
              <div className={"approverEmail"}>{member.email}</div>
            </div>
            <div className={"frame"}>
              <div className={"approval"}>
                <div className={approvalStatusStyle}>
                  <span className={"approvalIcon"}>{approvalIcon}</span>{" "}
                  <div className={statusStyle}>
                    {member.decision === "ACCEPT"
                      ? _("approvalAccepted")
                      : member.decision === "DENY"
                        ? _("approvalRejected")
                        : _("pendingApproval")}
                  </div>
                </div>
                <div className={"approvalDate"}>
                  {decisionText} {formattedDate}
                </div>
              </div>
              {member.decision !== "ACCEPT" && !hideSendButton &&(
                <button
                  className={"approveButton"}
                  onClick={() => handleSingleApprovalClick(member.email)}
                >
                  {_("resendApproval")}
                </button>
              )}
            </div>
          </div>

          {member.decision === "DENY" && (
            <div style={{ width: "100%" }}>
              <div
                className={"textFrame"}
                style={{
                  height:
                    showFullText || member.reason.split(" ").length <= 21
                      ? "100%"
                      : "4.5em",
                  overflow: "hidden",
                }}
              >
                {member.reason}
              </div>
              {member.reason.split(" ").length > 21 && (
                <span
                  className={"readMore"}
                  onClick={this.toggleShowFullText}
                >
                  {showFullText ? _("Reduce") : _("readMore")}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    sentAt: store.currentCampaign.email.sentAt,
  };
};

export default connect(mapStateToProps)(TTPCard);
